"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeEmail = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const Modal_1 = require("./Modal");
const form_1 = require("../../molecules/form/form");
const form_2 = require("../../atoms/form");
const react_hook_form_1 = require("react-hook-form");
const buttons_1 = require("../../atoms/buttons");
const react_i18next_1 = require("react-i18next");
var formKey;
(function (formKey) {
    formKey["email"] = "email";
})(formKey || (formKey = {}));
const ChangeEmail = ({ email = "", onSubmit, onCloseModal }) => {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)("md");
    const { handleSubmit, register, formState: { errors }, setFocus } = (0, react_hook_form_1.useForm)({
        defaultValues: {
            [formKey.email]: email
        }
    });
    (0, react_1.useEffect)(() => {
        setFocus(formKey.email);
    }, []);
    return ((0, jsx_runtime_1.jsx)(Modal_1.Modal, { title: t("emailModal.title"), variant: "small", children: (0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsxs)(form_1.Form, { variant: "vertical", onSubmit: handleSubmit(onSubmit), children: [(0, jsx_runtime_1.jsx)("label", { children: t("emailModal.label") }, void 0), (0, jsx_runtime_1.jsx)(form_2.Input, { placeholder: t("emailModal.placeholder"), err: (_a = errors[formKey.email]) === null || _a === void 0 ? void 0 : _a.message, type: "email", ...register(formKey.email, {
                            required: { value: true, message: t("errors.inputEmpty") }
                        }), name: formKey.email }, void 0), (0, jsx_runtime_1.jsx)("input", { type: "submit", hidden: true }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "secondary", onClick: onCloseModal, children: t("emailModal.cancel") }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { type: "submit", variant: "primary", children: t("emailModal.submit") }, void 0)] }, void 0)] }, void 0) }, void 0) }, void 0));
};
exports.ChangeEmail = ChangeEmail;
const Wrapper = styled_components_1.default.div `
  form {
    margin-bottom: 0;
  }

  form div:last-of-type {
    display: flex;
    margin-top: ${({ theme }) => theme.spacings.xxl};
    width: 100%;

    button {
      margin-bottom: 0;
    }

    & > button:first-of-type {
      margin-right: ${({ theme }) => theme.spacings.s};
    }
  }
`;
//# sourceMappingURL=ChangeEmail.js.map